import {
  useCreateUser,
  useGetUserDetails,
} from "../../../hooks/api/user/hooks";
import { useMessageApi } from "../../../provider/AntdNotification";
import ButtonWrapper from "../../../views/components/reuseComp/ButtonWrapper";
import { Form, Input, Spin, Switch } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  qData: any;
  id?: any;
}

const UsersForm: React.FC<Props> = ({ qData, id }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const message = useMessageApi();

  const isEditPage = Boolean(id);

  const { mutate: saveUser, isPending } = useCreateUser({ qData });
  const { data: users, isLoading } = useGetUserDetails(id);

  useEffect(() => {
    if (isEditPage && users?.data) {
      form.setFieldsValue({
        name: users.data.name,
        email: users.data.email,
        status: users.data.status,
      });
    }
  }, [isEditPage, users, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      saveUser(
        { ...values, _id: id },
        {
          onSuccess: () => {
            message.success(
              isEditPage
                ? "User updated successfully"
                : "User created successfully"
            );
            navigate(-1);
          },
          onError: (err: any) => {
            const msg =
              err?.response?.data?.message ||
              err?.message ||
              "Failed to save user";

            message.error(msg);
          },
        }
      );
    } catch (err) {
      console.error(err);
    }
  };

   const showSpinner = isEditPage && isLoading;

  return (
    <div>
      <div className="bg-[#F9F9F9] p-3 md:p-6 rounded-2xl shadow-sm mb-6">
         <Spin
            spinning={showSpinner}
            tip="Loading user details..."
            size="large"
          >
        <Form layout="vertical" form={form}>
          <Form.Item
            label="User Name"
            name="name"
            rules={[{ required: true, message: "Please enter user name" }]}
          >
            <Input placeholder="User Name" />
          </Form.Item>
          <Form.Item
            label="User Email"
            name="email"
            rules={[{ required: true, message: "Please enter user email" }]}
          >
            <Input placeholder="User Email" />
          </Form.Item>
         <Form.Item
          label="User Password"
          name="password"
          rules={[
            {
              required: !isEditPage,
              message: "Please enter user password",
            },
          ]}
        >
          <Input.Password placeholder="User Password" />
        </Form.Item>


          <Form.Item
            label="Status"
            name="status"
            valuePropName="checked"
            rules={[{ required: true, message: "Please select status" }]}
          >
            <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
          </Form.Item>
        </Form>
        </Spin>
      </div>
      <div className="flex justify-start gap-3 mt-7 sticky bottom-5">
        <ButtonWrapper type="primary" onClick={handleSave} loading={isPending}>
          Save
        </ButtonWrapper>
        <ButtonWrapper onClick={() => navigate(-1)}>Cancel</ButtonWrapper>
      </div>
    </div>
  );
};

export default UsersForm;
